import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { useIntl } from 'react-intl';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { ErrorBoundary } from '@repo/shared-kit/utils';
import { ErrorState } from '@repo/design-system-kit';
import { MainLayout } from '../../../components/layouts/main/main-layout';
import { ContentWrapper } from '../../../components/content-wrapper/content-wrapper';
import { KycLoading } from './loading';
import styles from './kyc.module.css';

export function KycLayout() {
  const { formatMessage } = useIntl();

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          fallbackRender={({ resetErrorBoundary }) => (
            <ErrorState
              onRetry={resetErrorBoundary}
              retryButtonText={formatMessage({
                defaultMessage: 'Try again',
                id: 'generic.try-again.cta',
              })}
              retryButtonVariant="primary"
              subtitle={formatMessage({
                defaultMessage: 'An error occurred. Please try again later.',
                id: 'errors.internal-server-error',
              })}
              title={formatMessage({
                defaultMessage: 'An error occurred',
                id: 'generic.error.title',
              })}
            />
          )}
          onReset={reset}
        >
          <Suspense fallback={<KycLoading />}>
            <MainLayout>
              <ContentWrapper>
                <div className={styles.container}>
                  <Outlet />
                </div>
              </ContentWrapper>
            </MainLayout>
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
